<template>
  <div id="app">
    <div id="nav">
<el-row>
<el-col :span="10" :offset="3"><div class="left">
<router-link to="/"><img src="./assets/1111.png" alt=""></router-link>
<!-- <span v-show="WidthSize > 415"><router-link to="/">快乐二进制</router-link></span> -->
</div></el-col>
<el-col :span="10">
<div class="right">
<ul v-if="showing">
	<li><router-link to="/register">注册</router-link></li>
	<li><router-link to="/login">登录</router-link></li>
</ul>
<div class="touxiang" style="float: right;" v-else> <router-link :to="'/administration/username=' + token "><img :src="logUrl" alt=""></router-link>
<p>{{name}}</p>
<p @click="logOut">退出</p></div>

</div></el-col>
</el-row>
      <router-link to="/"></router-link>
      <router-link to="/about"></router-link>
    </div>
    <!-- <rem/> -->
    <router-view/>
    <div class="bottm">
      <ul>
        <li>上海火岩数字技术有限公司</li>
        <li>地址:上海市浦东新区新场古镇汇友路70号</li>
        <li><a href="https://beian.miit.gov.cn/" style ="color:white">沪ICP备20008719号-2 快乐二进制少儿编程</a></li>
      </ul>
    </div>
<el-backtop target=".bottm" :bottom="100">
    <div class="up"
      style="{
        height: 100%;
        width: 100%;
        background-color: #f2f5f6;
        box-shadow: 0 0 6px rgba(0,0,0, .12);
        text-align: center;
        line-height: 40px;
        color: #1989fa;
      }"
    >
      UP
    </div>
  </el-backtop>
  </div>
</template>

<script>
// import rem from "./rem/rem.js"
export default {
	name:'app',
  data() {
    return {
      showing:true,
      WidthSize: 1010,
      token:'',
      logUrl:'',
      name:''
    }
  },
	created() {
		this.$store.dispatch('getHome');
    this.$store.dispatch('getAll');
    // console.log(window.location.href);

    window.addEventListener('resize', this.handleResize);
    console.log("被你发现了,快加入我们吧%c\n     ","font-size:120px;background:url('http://123.206.54.57/courseware/happybinaryonline/image/booksimage/hb_LiteracyReading.png')");
    this.log();
    console.log(navigator.userAgent.indexOf('AppleWebKit') > -1) ;//pc
	},
  mounted(){
   this.wxLogin();
  },
  beforeRouteEnter(to, from ,next) {
    to,
    from,
    next(console.log("我进入了这个网站了"))

  },
  computed: {
    home2 () {
      return this.$store.state.HomeModule.home2
    },
  },
methods:{
  // 微信登录
  wxLogin() {
    console.log(window.location.href.length)
    // 判断是否正常登录
    // 微信登录中。。
    if(75<= window.location.href.length && window.location.href.length <= 85) {
      console.log('现在是微信登录')
      let url = window.location.href;
      let url2 = url.split("=")
      let url3 = url2[1].split('&')
      let url4 = url3[0]
      this.$store.dispatch('wxLogin',url4).then((res) => {
        // console.log(res)
        if(res.data.code == 0) {

          if(!this.$cookie.get('token')) {
            sessionStorage.setItem('access', res.data.access_token)
            this.$router.push('/wxLogin');
          }else {
            return false
          }

        }else {
          localStorage.setItem('img',res.data.context.HeadImgurl);
          this.$cookie.set('token',res.data.context.token);
          localStorage.setItem('name',res.data.context.NickName)
          this.$message({
                    message: '正在检验信息',
                    type: 'success'
          });
          setTimeout(() => {
            window.location.reload()
          },3000)
        }

      })
      //支付宝支付完成的回调
    }else if( window.location.href.length >= 650 && window.location.href.length <= 700){
      // return false
      let urle = window.location.href;
      let urle2 = urle.split('/');
      let urle3 = urle2[4].split('?');
      let urle4 = urle3[1]
      sessionStorage.setItem('urle',urle4)
      this.$message({
                message: '正在跳转页面请您稍等...',
                type: 'success'
      });
      setTimeout(() => {
        this.$router.push('/payment/status')
      },1000)
      console.log('现在是支付宝')
      // 正常进入页面
    }else {
      console.log('正常进入')
    }

  },
  // 退出登录
  logOut() {
    console.log("我弹出了")
    let deToken = this.$cookie.get('token')
	this.showing = true
    this.$store.dispatch('deleta',deToken).then((res) => {
      // console.log(res)
      if(res.data.code == 0) {
        this.$cookie.delete('token')

        setTimeout(() => {
          // this.$router.push('/login')
          window.location.reload()
        },2000)
      }else{
       alert("不明原因，阻止了你的退出")
      }
    })
  },
  // 获取页面的宽度
  handleResizeing() {
      this.WidthSize = window.outerWidth
  },
  // pc自适应
  handleResize(e) {
    this.WidthSize = e.currentTarget.innerWidth
  },
  // 判断登录状态
  log() {
    // console.log(this.$cookie.get('token'))
    if(this.$cookie.get('token')) {
      // console.log("我存在")
      this.showing = false
      this.logUrl = localStorage.getItem('img')
      this.token = this.$cookie.get('token')
      if(sessionStorage.getItem('TwoName')) {
        this.name = sessionStorage.getItem('TwoName')
      }else {
        this.name = localStorage.getItem('name')
      }

    }else {
      this.showing = true
    }
  }
}
}
</script>

<style lang="scss">
  .touxiang {
    margin-right: 0.3rem;
    cursor: pointer;
    position: relative;
    img {
      // margin-top: -0.1rem;
      position: absolute;
      width: 0.7rem;
      height: 0.7rem;
      border-radius: 50%;
      top: 0.18rem;
      // background-color: red;
    }
    p{
      position: absolute;
      right: 0.2rem;
      display: inline-block;
      top: 0.2rem;
      width: 2rem;
      // background-color: red;
    }
    p:last-child {
      top:0.6rem;
    }
    // p {
    //   color: #212121;
    //   // letter-spacing: 1px;
    //   font-weight: 500;
    //   margin-top: -0.4rem;
    //   margin-left: -120px;
    // }
    // p:last-child{
    //   margin-top: 10px;
    // }
    p:hover {
      color: blue;

    }
  }
body {
  width: 100%;
}
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  width: 100%;

}
ul li {
	list-style: none;
	cursor: pointer;
}
a {
	text-decoration: none;
	color: #212121;
}
* {
	padding: 0rem;
	margin: 0rem;
}
#nav {
  width: 100%;
  // height: 1.5rem;
}
.left {
  img {
    float: left;
    display: inline-block;
    width: 4.1rem;
    height: 1.2rem;
  }
//   span {
//     float: left;
//     display: inline-block;
//     width: 70%;
// height: 1.2rem;
// font-size: 0.3rem;
// line-height: 1.2rem;
// // background-color: red;
// // color: blue;
// text-align: left;
// a {
// float: left;
// display: inline-block;
// // font-size: 1.25rem;
// color: #3268ce;
// font-family: '宋体';
// font-weight: 600;
// }
// a:hover {
// color: blue;
// }
//   }
}
.left,.right {
margin-top: 0.2rem;
		height: 1.2rem;
		// background-color: red;
		color: #212121;

	}
	.right {
		// background-color: red;
		ul {
			// position: re;
			float: roght;
      font-size: 0.3rem;
			li {
				float: right;
				// line-height: 1.5rem;
        line-height: 1.2rem;
				margin-right: 0.5rem;
				a: {
					color: #3268ce;
          // transition: all 0.5s;
				}
				a:hover{
          // transition: all 0.5s;
					color: #BFC7D3;
          // font-size: 0.4rem;
				}
			}
		}
	}
  .bottm {
    // position: fixed;
    // left: 0rem;
    // bottom: 0rem;
    width: 100%;
    height: 2rem;
    background-color: #212121;
    color: #FFFFFF;
    overflow: hidden;

    ul {
      li {
        opacity: 0.8;
        line-height: 0.4rem;
        letter-spacing: 0.01rem;
        cursor: pointer;
      }

      li:hover {
        color: #e83e8c;
      }

      li:first-child {
        margin-top: 0.4rem;

      }
    }
  }
</style>
